<select
  [formControl]="selectionControl"
  [ngClass]="{
    'w-full': fullWidth,
    'unsaved-field': unsavedChanges,
  }"
  class="border text-sm rounded-lg block p-2.5 min-w-34 bg-amazone-gray border-amazone-gray hover:bg-gray-800 placeholder-gray-400 text-white focus:ring-amazone-orange focus:border-amazone-orange disabled:cursor-not-allowed"
>
  @for (option of options; track $index) {
    <option [selected]="isSelected(option)" value="{{ option.id }}">
      {{ option.title }}
    </option>
  }
</select>
